import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable, of, shareReplay } from 'rxjs';
import { Common } from 'src/_lib/interfaces/common.interface';
import { MiddlearticlesInterface } from 'src/_lib/interfaces/performance-section.interface';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root',
})
export class WebinfoService {
  endpoint: string = environment.apiUrl;
  middleArticlesCache$?: Observable<Common<MiddlearticlesInterface>> | null = null;

  constructor(private browser: BrowserService, private http: HttpClient) { }

  infoList(): Observable<Common<MiddlearticlesInterface>> {
    if (this.middleArticlesCache$) {
      return this.middleArticlesCache$;
    }
    const storedData = this.getFromStorage();
    if (storedData) {
      this.middleArticlesCache$ = of(storedData).pipe(shareReplay(1));
      return this.middleArticlesCache$;
    }
    this.middleArticlesCache$ = this.http
      .get<Common<MiddlearticlesInterface>>(this.endpoint + 'middlearticles')
      .pipe(shareReplay(1));
    this.middleArticlesCache$.subscribe(data => {
      this.saveToStorage(data);
    });
    return this.middleArticlesCache$;
  }

  saveToStorage(data: Common<MiddlearticlesInterface>): void {
    this.browser.localStorage?.setItem('middleArticleData', JSON.stringify(data));
  }

  getFromStorage(): Common<MiddlearticlesInterface> | null {
    const data = this.browser.localStorage?.getItem('middleArticleData');
    return data ? JSON.parse(data) : null;
  }

  subscribe(email: string): Observable<any> {
    return this.http.post(this.endpoint + 'customer-subscribe', {
      email_address: email
    });
  }

  product_notify(data: any): Observable<any> {
    return this.http.post(this.endpoint + 'inventory-notify-request',data);
  }
}